import React from 'react';
import { Box } from 'theme-ui';

export const ScoreBar = ({ color, score }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        maxWidth: '360px',
        height: '15px',
        borderRadius: '9999px',
        background: '#fff',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          width: 'inherit',
          height: '100%',
          borderRadius: 'inherit',
          background: `${color}25`,
        }}
      >
        <Box
          sx={{
            width: `${score}%`,
            height: '100%',
            borderRadius: 'inherit',
            background: color,
            transition: 'all 0.3s',
          }}
        />
      </Box>
    </Box>
  );
};
